import { default as CommonTools } from '../utils/common'
import { default as mapApp } from '@/map/init.js'

/**
 * 码头管理
 */
export default class WharfMapActions {
    constructor(map) {
        this.map = map

        this.floor = null
        this.imageLayer = null
        this.textLayer = null
        this.lineEffectLayer = null

        this.isInitComplete = false
        // 码头弹窗组件列表
        this.wharfPopVueComponents = []
        // 带坐标的
        this.wharfPopData = []
        this.wharfPopMarkerList = []

        this.polyLayer = null
        // 泊位点集
        this.berthData = []
        // 搜索建议
        this.searchSuggestions = []
    }

    // 外部初始化
    init () {
        if (this.isInitComplete) {
            this.resetView()

            return
        }
        this._init()
        this.isInitComplete = true
        this.loadActionData()
    }

    // 内部首次初始化层对象至地图
    _init () {
        // 获取层
        this.floor = this.map.getBuildingById(0).getFloor(1)
        this.polyLayer = this.floor.getOrCreateLayerByName('poly', esmap.ESLayerType.POLYGON_MARKER)

        // layer name 都填上好对应交互名称(建议唯一)，方便以后全局查找层对象
        //创建普通标注层
        this.textLayer = this.floor.getOrCreateLayerByName('wharf_text', esmap.ESLayerType.TEXT_MARKER)
        //创建特效标注层
        // this.lineEffectLayer = new esmap.ESEffectTool.EffectLayer('boatsLine', esmap.ESLayer.EFFECT_MARKER);

        // this.floor.addLayer(this.imageLayer);
        // esmap.ESEffectTool.addLayerToMap(this.lineEffectLayer);
    }
    // 重置视角
    resetView () {
        this.wharfPageFly()
    }

    // 加载当前交互模块基础配置数据
    loadActionData () {
        esmap.ESJsonFileLoader('./assets/actions/wharf.json').then((data) => {
            // 这里的wharfPopData 包括了泊位、观测站、监控、吊机等等
            this.wharfPopData = data.wharfPopMarkersData;
            // this.berthData = data.berthBoundings;
        })
    }

    // 管理地图点击
    managerMapClick () { }

    // 查找模型接口
    searchModels (value) {
        let self = this
        return new Promise((resolve, reject) => {
            esmap.ESMapUtil.search(this.map, "all", {
                types: [
                    // esmap.ESLayerType.MODEL,  // (房间)
                    // esmap.ESLayerType.MODEL_LABEL,  // (文字label)
                    // esmap.ESLayerType.MODEL_POI, // (图片poi)
                    // esmap.ESLayerType.IMAGE_MARKER, // (自定义图片标注)
                    // esmap.ESLayerType.TEXT_MARKER, // (自定义文字标注)
                    esmap.ESLayerType.MODEL3D, // (三维模型标注)
                ],
                keyword: value
            }, function (e) {
                self.searchSuggestions = e;
                resolve(e);
            })
        })
    }
    // 当前页默认飞行视角
    wharfPageFly () {
        let self = this
        mapApp.mapContainer.clickShadeSign = true
        mapApp.wharfVueComponent.isShowWharfPop = false;
        this.map.cameraFlyTo({
            directionAngle: 331.48,
            pitchAngle: 68.6,
            radius: 1074.05,
            x: 13150500.24,
            y: 4749900.94,
            z: 0,
            callback: function () {
                if (mapApp.homeVueComponent.btnShowBerth && !mapApp.wharfVueComponent.isPopMarkerAdd) {
                    mapApp.wharfVueComponent.addPopWharf()//绑定码头气泡位置 
                    self.clearPolyMarkerEffect()//清除一遍标注层
                    self.showBerthPop()//开启码头泊位的气泡和多边形
                }
                mapApp.mapContainer.clickShadeSign = false
                mapApp.wharfVueComponent.isShowWharfPop = true;
            }
        })
    }

    // 选中数据的指定船只位置飞行
    targetBoatFly (data) {
        mapApp.mapContainer.clickShadeSign = true
        this.map.cameraFlyTo({
            directionAngle: 35.53, pitchAngle: 63.84, radius: 166.14,
            x: data.x,
            y: data.y,
            z: 0,
            time: 2,
            callback: function () {
                mapApp.mapContainer.clickShadeSign = false
            }
        })
    }

    // 码头各种设备弹窗（统一生成，根据切换tab项来控制显示分类）
    showWharfPopMarker () {
        // console.log(this.wharfPopData)
        // console.log(this.wharfPopVueComponents)
        let that = this
        for (let i = 0; i < that.wharfPopData.length; i++) {
            // 创建marker
            let marker = CommonTools.addPopMarker(that.wharfPopData[i]);
            // 绑定name
            marker.bindName = that.wharfPopData[i].name;
            // 用于控制泊位显示
            that.wharfPopVueComponents[i].currPopName = that.wharfPopData[i].name;
            that.wharfPopMarkerList.push(marker)
            that.wharfPopMarkerList[i].onUpdatePosition(function (transformStyle, displayStyle) {
                that.wharfPopVueComponents[i].popTips.transformStyle = transformStyle
                that.wharfPopVueComponents[i].popTips.visible = (displayStyle.display === 'none') ? false : true
            })
        }
    }

    // toggleWharfPopMarker(isShow) {
    //     for(let i=0, len=this.wharfPopMarkerList.length; i<len; i++) {
    //         this.wharfPopMarkerList[i].visible = isShow;
    //         this.wharfPopVueComponents[i].popTips.visible = isShow;
    //     }
    // }

    // 展示监控弹框
    showMonitoringPopMarker () {
        mapApp.mapContainer.clickShadeSign = true
        mapApp.wharfVueComponent.isShowWharfPop = false;
        this.map.cameraFlyTo({
            directionAngle: 344.41,
            pitchAngle: 66.75,
            radius: 773.49,
            x: 13150751.38,
            y: 4750717.73,
            z: 0,
            time: 2,
            callback: function () {
                mapApp.mapContainer.clickShadeSign = false
                mapApp.wharfVueComponent.isShowWharfPop = true;
            }
        })

    }
    // 展示泊位弹框
    showBerthPopMarker () {
        mapApp.mapContainer.clickShadeSign = true
        if (mapApp.wharfVueComponent) { mapApp.wharfVueComponent.isShowWharfPop = false }
        this.map.cameraFlyTo({
            directionAngle: 331.48,
            pitchAngle: 55.03,
            radius: 1030.87,
            x: 13150635.98,
            y: 4749879.33,
            z: 0,
            time: 2,
            callback: () => {
                this.showBerthPop()
            }
        })
    }
    //展示码头泊位气泡
    showBerthPop () {
        mapApp.mapContainer.clickShadeSign = true
        if (mapApp.wharfVueComponent) { mapApp.wharfVueComponent.isShowWharfPop = false }
        for (let i = 0; i < this.berthData.length; i++) {
            let polygonMarker = this.addPolygonMarker(this.berthData[i].points)
            let centerPos = polygonMarker.getCenter();
            this.addBerthTextMarker({ name: this.berthData[i].name, x: centerPos.x, y: centerPos.y, dataID: this.berthData[i].dataID });
            for (let popMarker of this.wharfPopMarkerList) {
                for (let popVue of this.wharfPopVueComponents) {
                    if (this.berthData[i].name.indexOf(popMarker.bindName) > -1 && this.berthData[i].name.indexOf(popVue.currPopName) > -1) {
                        this.updatePopMarker(popMarker, popVue, centerPos);
                        break;
                    }
                }
            }
            this.polyLayer.addMarker(polygonMarker)
        }
        if (mapApp.wharfVueComponent) mapApp.wharfVueComponent.isShowWharfPop = true;
        mapApp.mapContainer.clickShadeSign = false
    }
    // 展示设施弹框
    showFacilityPopMarker () {
        mapApp.mapContainer.clickShadeSign = true
        mapApp.wharfVueComponent.isShowWharfPop = false;
        this.map.cameraFlyTo({
            "directionAngle": 67.52, "pitchAngle": 22.74, "radius": 1214.75, "x": 13150684.1, "y": 4750019.2, "z": 0,
            time: 2,
            callback: function () {
                mapApp.mapContainer.clickShadeSign = false
                mapApp.wharfVueComponent.isShowWharfPop = true;
            }
        })
    }

    // 更新气泡弹窗
    updatePopMarker (popMarker, popVueComponents, data) {
        if (popMarker) {
            popMarker.moveTo({ x: data.x, y: data.y, time: 0 })
            popVueComponents.popTips.visible = true
        }
    }

    // 关闭所有气泡
    closeWharfPop () {
        // 清除气泡对象
        if (this.wharfPopMarkerList.length > 0) {
            for (let marker of this.wharfPopMarkerList) {
                if (marker) marker.close()
            }
        }
        this.wharfPopMarkerList = []
        // 清除 vue 气泡组件引用( vue 组件销毁)
        for (let popVueCom of this.wharfPopVueComponents) {
            if (popVueCom) popVueCom.popTips.visible = false
        }
    }
    // 泊位多边形 marker
    addPolygonMarker (coords) {
        return new esmap.ESPolygonMarker({
            //设置颜色
            color: '#62fffa',
            //设置透明度
            alpha: 0.2,
            //设置边框线的宽度
            lineWidth: 15,
            lineType: esmap.ESLineType.DOT_DASH,
            //设置高度
            height: -3,
            points: coords,
            seeThrough: false
        })
    }
    // 清除多边形 marker
    clearPolyMarkerEffect () {
        if (this.polyLayer) {
            this.polyLayer.removeAll()
        }
        if (this.textLayer) this.textLayer.removeAll()
    }

    // 添加泊位文字标注
    addBerthTextMarker (data) {
        let marker = CommonTools.addTextMarker({
            id: 'berth_' + data.dataID,
            name: data.name,
            x: data.x,
            y: data.y,
            text: data.dataID,
            offsetHeight: 2,
            fontsize: 30,
            scale: 50,
            seeThrough: true,
            showLevel: 17
        })
        this.textLayer.addMarker(marker)
    }


    // 隐藏用于辅助绘制泊位房间块边界
    hiddenAreaBounding (keyword, targetArr) {
        return this.searchRooms(keyword).then(result => {
            if (result && result.length > 0) {
                for (let i = 0, len = result.length; i < len; i++) {
                    result[i].o3d_.visible = false;
                    let points = this.map.ol(result[i].ID, this.map.options.cids);
                    targetArr.push({ name: result[i].name, points: points[0], dataID: result[i].dataID })
                }
            }
        })
    }

    // 查找房间接口
    searchRooms (value) {
        return new Promise((resolve, reject) => {
            esmap.ESMapUtil.search(this.map, "all", {
                types: [
                    esmap.ESLayerType.MODEL,  // (房间)
                    // esmap.ESLayerType.MODEL_LABEL,  // (文字label)
                    // esmap.ESLayerType.MODEL_POI, // (图片poi)
                    // esmap.ESLayerType.IMAGE_MARKER, // (自定义图片标注)
                    // esmap.ESLayerType.TEXT_MARKER, // (自定义文字标注)
                    // esmap.ESLayerType.MODEL3D, // (三维模型标注)
                ],
                keyword: value
            }, function (e) {
                resolve(e);
            })
        })
    }

}
